import {Component, Inject, Vue} from 'vue-property-decorator'
import {ActiveInject} from "@/support/reactive"

@Component
export default class MonitorMixin extends Vue {

    @ActiveInject({from: 'jds.monitor', default: null}) $monitor!: Vue;

    $debug (message: string, code?: string, context?: {[key: string]: any}) {
        if (this.$monitor) {
            this.$monitor.$emit('debug', {
                message: message,
                code: code,
                source: this.$options.name,
                level: 'debug',
                context
            })
        }
    }

    $info (message: string, code?: string, context?: {[key: string]: any}) {
        if (this.$monitor) {
            this.$monitor.$emit('info', {
                message: message,
                code: code,
                source: this.$options.name,
                level: 'info',
                context
            })
        }
    }

    $warn (message: string, code?: string, context?: {[key: string]: any}) {
        if (this.$monitor) {
            this.$monitor.$emit('warn', {
                message: message,
                code: code,
                source: this.$options.name,
                el: this.$el,
                level: 'warn',
                context
            })
        }
    }

    $error (message: string, code?: string, context?: {[key: string]: any}) {
        if (this.$monitor) {
            this.$monitor.$emit('error', {
                message: message,
                code: code,
                source: this.$options.name,
                el: this.$el,
                level: 'error',
                context
            })
        }
    }
}
